var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[_c('div',{class:{
      map_limited: _vm.showOrderMapWindow,
    },attrs:{"id":"gmap"}}),(_vm.showOrderMapWindow && _vm.order != null)?_c('div',{staticClass:"map-order",class:{
      'map-order_show': _vm.showAnimation,
    }},[_vm._v(" > "),_c('orders-modal')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }